import { compactForMatch, sameName } from './personNameMatch';

const SKIP_NAME_PATTERNS = [/合計/, /小計/, /計$/];

function shouldSkipUploadedName(name: string): boolean {
  const t = name.trim();
  if (!t) return true;
  return SKIP_NAME_PATTERNS.some((re) => re.test(t));
}

function parseCsvLine(line: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const c = line[i];
    if (c === '"') {
      inQuotes = !inQuotes;
    } else if (c === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += c;
    }
  }
  result.push(current.trim());
  return result;
}

/** Extract unique 名前 values from a construction salary CSV/TXT (header has 名前). */
export function extractConstructionSalaryEmployeeNames(content: string): string[] {
  const text = content.replace(/^\uFEFF/, '');
  const lines = text.split(/\r?\n/).filter((line) => line.trim() !== '');
  if (lines.length < 2) {
    return [];
  }
  const headers = parseCsvLine(lines[0]).map((h) => h.replace(/^"|"$/g, '').trim());
  const nameIdx = headers.indexOf('名前');
  if (nameIdx < 0) {
    return [];
  }
  const names: string[] = [];
  const seen = new Set<string>();
  for (let i = 1; i < lines.length; i++) {
    const cells = parseCsvLine(lines[i]).map((c) => c.replace(/^"|"$/g, ''));
    const employeeName = (cells[nameIdx] ?? '').trim();
    if (shouldSkipUploadedName(employeeName)) continue;
    const key = compactForMatch(employeeName);
    if (!key || seen.has(key)) continue;
    seen.add(key);
    names.push(employeeName);
  }
  return names;
}

/**
 * Names in the TXT that are not an exact compact match to a registered account.
 * Partial / substring matches are treated as unregistered (same alert).
 */
export function findUnregisteredUploadedNames(
  uploadedNames: string[],
  registeredNames: string[]
): string[] {
  const unmatched: string[] = [];
  const seenUploaded = new Set<string>();

  for (const raw of uploadedNames) {
    const uploadedName = raw.trim();
    if (shouldSkipUploadedName(uploadedName)) continue;
    const key = compactForMatch(uploadedName);
    if (!key || seenUploaded.has(key)) continue;
    seenUploaded.add(key);

    if (registeredNames.some((r) => sameName(uploadedName, r))) {
      continue;
    }
    unmatched.push(uploadedName);
  }

  return unmatched;
}

export function formatUnregisteredNamesAlert(unregisteredNames: string[]): string {
  if (unregisteredNames.length === 0) {
    return '';
  }
  const list = unregisteredNames.map((n) => `${n}様`).join('、');
  return `${list}はシステムに登録されていません。`;
}
